import axios from "axios";

class crudApi {
    constructor(endpoint) {
        this.endpoint = endpoint
    }

    async all(options = {}) {

        let data = await axios.get(this.endpoint, options);

        const paginationIsAked = !!options && !!options.params && !!options.params.page;
        const resultIsPaginated = !!data.data.meta && !!data.data.meta.last_page && !!data.data.meta.current_page;

        if (paginationIsAked && resultIsPaginated && data.data.meta.last_page < data.data.meta.current_page) {
            options.params.page = data.data.meta.last_page;
            data = await this.all(options);
        }

        return data;
    }

    async create(data, options = {}) {
        return await axios.post(this.endpoint, data, options)
    }

    async edit(id, data, options = {}) {
        return await axios.patch(this.endpoint + `/${id}`, data, options)
    }

    async show(id, options = {}) {
        return await axios.get(this.endpoint + `/${id}`, options)
    }

    async remove(id, options = {}) {
        return await axios.delete(this.endpoint + `/${id}`, options)
    }

}

export default crudApi;
